module.exports = __webpack_public_path__ + "static/media/brainayan-log-new.995d8758.svg";